import React, { type FC } from 'react';

import { useIntl } from 'react-intl';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Pressable, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';

const baseStyles = xcss({
	height: '40px',
	width: '44px',
	borderRadius: 'radius.small',
	border: 'none',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
	position: 'relative' as any,
});

const selectedStyles = xcss({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
	boxShadow: `inset 0 0 0 2px ${token('color.border.selected')}` as any,
});

const noImageStyles = xcss({
	backgroundColor: 'color.background.neutral.subtle',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
	boxShadow: `inset 0 0 0 1px ${token('color.border')}` as any,
	position: 'relative',
});

const noImageLineStyles = xcss({
	position: 'absolute',
	left: '50%',
	top: '5%',
	height: '90%',
	borderWidth: 'border.width',
	borderStyle: 'solid',
	borderColor: 'color.border',
	rotate: '45deg',
});

type NoImageThumbnailProps = {
	children?: React.ReactNode;
	isSelected: boolean;
	onClick: () => void;
};

export const NoImageThumbnail: FC<NoImageThumbnailProps> = ({ onClick, isSelected, children }) => {
	const intl = useIntl();
	return (
		<Pressable
			xcss={[baseStyles, noImageStyles, isSelected && selectedStyles]}
			testId="unsplash-no-image"
			aria-label={intl.formatMessage(messages.noImageLabel)}
			onClick={onClick}
		>
			<Box xcss={noImageLineStyles} />
			{children}
		</Pressable>
	);
};
